var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWipers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.5 8.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000d20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_2",
    "data-name": "Lager 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lager_2-2",
    "data-name": "Lager 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.15,7.89a.25.25,0,0,1-.14,0,10.33,10.33,0,0,0-10.52,0,.28.28,0,0,1-.38-.1L.22,2.86a.27.27,0,0,1,.1-.37,16.54,16.54,0,0,1,16.86,0,.27.27,0,0,1,.1.37L14.39,7.75A.27.27,0,0,1,14.15,7.89ZM.83,2.82,3.45,7.24a10.87,10.87,0,0,1,10.6,0l2.62-4.42a16.05,16.05,0,0,0-15.84,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.35,8.07A.47.47,0,0,1,3,7.85L.06,3a.48.48,0,0,1,0-.35.5.5,0,0,1,.21-.28,16.78,16.78,0,0,1,17.06,0,.48.48,0,0,1,.16.63L14.55,7.85a.49.49,0,0,1-.63.16A10.12,10.12,0,0,0,3.58,8,.46.46,0,0,1,3.35,8.07ZM8.75.37A16.41,16.41,0,0,0,.41,2.65a.06.06,0,0,0,0,.05.09.09,0,0,0,0,.07L3.27,7.66a.09.09,0,0,0,.12,0,10.57,10.57,0,0,1,10.72,0,.08.08,0,0,0,.12,0l2.89-4.89a.08.08,0,0,0,0-.12A16.41,16.41,0,0,0,8.75.37Zm5.37,7.12L14,7.4a10.75,10.75,0,0,0-10.43,0l-.16.09L.58,2.76l.16-.1a16.26,16.26,0,0,1,16,0l.16.1Zm-13-4.6L3.51,7A11.06,11.06,0,0,1,14,7l2.43-4.11a15.83,15.83,0,0,0-15.33,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.95,
    y: 4.65,
    width: 0.36,
    height: 1.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.76,
    y: 4.47,
    width: 0.73,
    height: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.88,
    y: 3.67,
    width: 3.52,
    height: 0.36,
    transform: "matrix(0.59, -0.81, 0.81, 0.59, 1.7, 11.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.69,
    y: 3.49,
    width: 3.88,
    height: 0.73,
    transform: "translate(1.7 11.02) rotate(-54.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.56,
    y: 4.65,
    width: 0.36,
    height: 1.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.38,
    y: 4.47,
    width: 0.73,
    height: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.49,
    y: 3.67,
    width: 3.52,
    height: 0.36,
    transform: "translate(-0.54 6.65) rotate(-54.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 3.49,
    width: 3.88,
    height: 0.73,
    transform: "translate(-0.54 6.65) rotate(-54.1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWipers);
export default __webpack_public_path__ + "static/media/wipers.9c0e5d49.svg";
export { ForwardRef as ReactComponent };